var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "bell")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.701 25.608l-5.016-6.963v-7.94c0-5.89-4.792-10.683-10.684-10.683-5.891 0-10.684 4.792-10.684 10.683v7.94l-5.016 6.963c-0.348 0.483-0.397 1.122-0.125 1.652 0.271 0.53 0.817 0.862 1.412 0.862h10.587c0 0.013-0.003 0.020-0.003 0.029 0 2.115 1.716 3.827 3.829 3.827s3.828-1.713 3.828-3.827c0-0.012-0.003-0.021-0.003-0.029h10.588c0.595 0 1.141-0.332 1.412-0.862 0.272-0.532 0.223-1.169-0.125-1.652zM4.686 24.948l3.505-4.865c0.195-0.27 0.299-0.595 0.299-0.928v-8.453c0-4.14 3.369-7.51 7.511-7.51s7.511 3.369 7.511 7.51v8.453c0 0.331 0.107 0.658 0.299 0.928l3.504 4.865h-22.628z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.fa942aba.svg";
export { ForwardRef as ReactComponent };